import React from "react";

export default ({ text, size }) => (
  <div className="loading-spinner">
    <i className={size ? `fas fa-spinner fa-spin ${size}` : "fas fa-spinner fa-spin"}></i>
    {text}
  </div>
);
